import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import BankService from '../../core/BankService'

export const postCapitalAdequacy = createAsyncThunk(
  'companyAnalysis/industryAnalysis/bank/capitalAdequacy',
  async (params, { rejectWithValue }) => {
    try {
      const res = await BankService.postCapitalAdequacy(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadCapitalAdequacy = createAsyncThunk(
  'companyAnalysis/industryAnalysis/bank/capitalAdequacy/export',
  async (params) => {
    try {
      const res = await BankService.downloadCapitalAdequacy(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
